import { createContext, useContext, type ReactNode } from 'react';

/**
 * Story #22197 — the phone-layout opt-in (BR-MOB-006, 007, 008, 011, 012).
 *
 * The shared components this Story changes (PageHeader, Tabs, Card, KpiStrip, Badge) are also used by
 * the client portal, whose prototype has no phone patterns yet (Feature #22239). So every NEW phone-only
 * behaviour is opt-in: a portal that wants it wraps its shell in `<PhoneLayoutProvider>` (the admin
 * portal does, in AdminLayout). With no provider the default is OFF and each component renders exactly
 * as it did before this Story, at every width.
 */
const PhoneLayoutContext = createContext(false);

export interface PhoneLayoutProviderProps {
  children: ReactNode;
  /** Defaults to true — the provider exists to switch the behaviour on. */
  enabled?: boolean;
}

export function PhoneLayoutProvider({ children, enabled = true }: PhoneLayoutProviderProps) {
  return <PhoneLayoutContext.Provider value={enabled}>{children}</PhoneLayoutContext.Provider>;
}

/** True when the surrounding portal has opted in to the BR-MOB phone patterns. */
export function usePhoneLayout(): boolean {
  return useContext(PhoneLayoutContext);
}
